/* eslint-disable react/no-unstable-nested-components */
import { ColumnDef } from '@tanstack/react-table';
import { TableWrapperProps } from 'models/general';
import { useMemo } from 'react';
import TableBase, { TableModifier } from './base/tableBase';
import { TableBaseApiKind } from './base/tableBaseApi';

export interface CsvPreviewTableDef {
  type: string;
  buy: number;
  currency_buy: string;
  sell: number;
  currency_sell: string;
  fee: string;
  account: string;
  trade_id: string;
  date: string;
}

function CsvPreviewTable(props: TableWrapperProps) {
  const { pageSize = 10, requestUri = 'csvPreviewTableData' } = props;

  const csvPreviewTableColumns: ColumnDef<CsvPreviewTableDef>[] = useMemo(() => [
    {
      accessorKey: 'type',
      cell: (info) => (<b>{ info.getValue() }</b>),
      header: 'Type',
    },
    {
      accessorKey: 'buy',
      cell: (info) => (<span>{ info.getValue() }</span>),
      header: 'Buy',
    },
    {
      accessorKey: 'currency_buy',
      cell: (info) => (<span>{ info.getValue() }</span>),
      header: 'Curr.',
    },
    {
      accessorKey: 'sell',
      cell: (info) => (<span>{ info.getValue() }</span>),
      header: 'Sell',
    },
    {
      accessorKey: 'currency_sell',
      cell: (info) => (<span>{ info.getValue() }</span>),
      header: 'Curr.',
    },
    {
      accessorKey: 'fee',
      cell: (info) => (<span>{ info.getValue() }</span>),
      header: 'Fee',
    },
    {
      accessorKey: 'account',
      cell: (info) => (<span>{ info.getValue() }</span>),
      header: 'Account',
    },
    {
      accessorKey: 'trade_id',
      cell: (info) => (<span>{ info.getValue() }</span>),
      header: 'Trade ID',
    },
    {
      accessorKey: 'date',
      cell: (info) => (<span>{ info.getValue() }</span>),
      header: 'Date',
    },
  ], []);

  return (
    <LegacyTableBase
      requestUri={requestUri}
      columns={csvPreviewTableColumns}
      apiKind={TableBaseApiKind.LAMINAS}
      modifier={TableModifier.CSV_PREVIEW_TABLE}
      pageSize={pageSize}
      mockData
    />
  );
}

export default CsvPreviewTable;
